import { LitElement, html, css } from 'lit-element';
import { Theme } from '@furo/framework/src/theme.js';
import { FBP } from '@furo/fbp';

/**
 * `make-empty-ausgabe-object`
 * Erstellt ein leere AusgabeEntity
 *
 * @customElement
 * @appliesMixin FBP
 */
class MakeEmptyAusgabeObject extends FBP(LitElement) {
  constructor() {
    super();
    this.newEmptyObject = {
      data: {},
      links: {},
    };
    this.zeitvorgabeIn = null;
  }

  qpIn(qp) {
    this._FBPTriggerWire('--qpIn', qp);
  }

  triggerCustomMethod() {
    this.setTodayAsZeitvorgabe();
    this._FBPTriggerWire('--triggerCustomMethod');
  }

  setTodayAsZeitvorgabe() {
    if (this.zeitvorgabeIn != null) {
      const today = new Date();
      const day = today.getDate();
      const month = today.getMonth() + 1;
      const year = today.getFullYear();

      this.zeitvorgabeIn.tag.day._value = day;
      this.zeitvorgabeIn.tag.month._value = month; // January is 0!;
      this.zeitvorgabeIn.tag.year._value = year;
      this._FBPTriggerWire('--zeitvorgabeIn', this.zeitvorgabeIn);
    }
  }

  /**
   * flow is ready lifecycle method
   */
  _FBPReady() {
    super._FBPReady();

    // this._FBPAddWireHook('--hts', hts => {
    //  const today = new Date();
    //  const rawObject = {
    //    data: {
    //      tag: {
    //        day: today.getDate(),
    //        month: today.getMonth() + 1, // January is 0!
    //        // eslint-disable-next-line no-param-reassign
    //        year: today.getFullYear(),
    //      },
    //      its_artikel: {
    //        link: {
    //          href: '/api/artikel',
    //          method: 'GET',
    //          rel: 'list',
    //          service: 'Artikel',
    //          type: 'artikel.Artikel',
    //        },
    //      },
    //    },
    //    links: hts,
    //  };
    //  /**
    //   * @event object-created
    //   * Fired when object-created
    //   * detail payload: empty object with links
    //   */
    //  const customEvent = new Event('object-created', { composed: true, bubbles: false });
    //  customEvent.detail = rawObject;
    //  this.dispatchEvent(customEvent);
    // });

    this._FBPAddWireHook('--htsUpdated', () => {
      this.setTodayAsZeitvorgabe();
      this._FBPTriggerWire('--triggerCustomMethod');
    });

    this._FBPAddWireHook('--vorgabeObjBack', e => {
      this.newEmptyObject.data = e.data;
      this.newEmptyObject.links = e.links;

      const customEvent = new Event('object-created', { composed: true, bubbles: false });
      customEvent.detail = this.newEmptyObject;
      this.dispatchEvent(customEvent);
    });

    this._FBPAddWireHook('--zeitvorgabeReady', e => {
      this.zeitvorgabeIn = e;
      this.setTodayAsZeitvorgabe();
      this._FBPTriggerWire('--zeitvorgabeIn', this.zeitvorgabeIn);
    });
  }

  /**
   * @private
   * @returns {TemplateResult}
   * @private
   */
  render() {
    // language=HTML
    return html`
      <furo-data-object
        type="arbeitsausgabe.Arbeitsausgabevorgabe"
        @-object-ready="--zeitvorgabeReady"
      ></furo-data-object>

      <furo-deep-link service="Arbeitsausgabe" ƒ-qp-in="--qpIn" @-hts-out="--hts"></furo-deep-link>

      <furo-custom-method
        service="Arbeitsausgabe"
        method="vorgabe"
        ƒ-hts-in="--hts"
        @-response="--vorgabeObjBack"
        @-hts-updated="--htsUpdated"
        ƒ-trigger="--triggerCustomMethod"
        ƒ-bind-request-data="--zeitvorgabeIn"
      ></furo-custom-method>
    `;
  }

  /**
   * Themable Styles
   * @private
   * @return {CSSResult}
   */
  static get styles() {
    // language=CSS
    return (
      Theme.getThemeForComponent('MakeEmptyAusgabeObject') ||
      css`
        :host {
          display: none;
        }
      `
    );
  }
}

window.customElements.define('make-empty-ausgabe-object', MakeEmptyAusgabeObject);
